

import React from "react";
import img1 from "./img/R3.jpg";
import img2 from "./img/20-FILES-.jpg";
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../../../locales/config";
import img1en from "./img/R3.jpg";
import img2en from "./img/20-FILES.jpg";
import img3en from "./img/123.jpg";

export function R3() {

    const lang = LOCALES_HELPER.getLan();

    return (
        <>
            {lang === DEFAULT_LOCALE
                ? <>
                    <img className="product-img" src={img1}/>
                    <img className="product-img" src={img2}/>
                </>

                : <>
                    <img className="product-img" src={img3en}/>
                    <img className="product-img" src={img1en}/>
                    <img className="product-img" src={img2en}/>
                </>

            }
        </>
    )
}